var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { staticClass: "form" },
    [
      !!_vm.pledge
        ? _c(
            "NavigationPanel",
            { staticClass: "sec-navigation" },
            [
              _c(
                "template",
                { slot: "nav" },
                [
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        tag:
                          _vm.$options.components &&
                          _vm.$options.components.NavItem,
                        exact: "",
                        to: `${_vm.baseUrl}`
                      }
                    },
                    [_vm._v("Pledge")]
                  ),
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        tag:
                          _vm.$options.components &&
                          _vm.$options.components.NavItem,
                        to: `${_vm.baseUrl}/payments`
                      }
                    },
                    [_vm._v("Payments")]
                  ),
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        tag:
                          _vm.$options.components &&
                          _vm.$options.components.NavItem,
                        to: `${_vm.baseUrl}/invoice`
                      }
                    },
                    [_vm._v("Invoice")]
                  ),
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        tag:
                          _vm.$options.components &&
                          _vm.$options.components.NavItem,
                        to: `${_vm.baseUrl}/receipts`
                      }
                    },
                    [_vm._v("Receipts")]
                  ),
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        tag:
                          _vm.$options.components &&
                          _vm.$options.components.NavItem,
                        to: `${_vm.baseUrl}/audit`
                      }
                    },
                    [_vm._v("Audit")]
                  )
                ],
                1
              ),
              _c(
                "template",
                { slot: "body" },
                [
                  _c(
                    "Box",
                    [
                      _c(
                        "MatchFirst",
                        [
                          _c(
                            "Route",
                            { attrs: { path: `${_vm.baseUrl}/payments` } },
                            [
                              _c(
                                "MatchFirst",
                                [
                                  _c(
                                    "Route",
                                    {
                                      attrs: {
                                        path: `${_vm.baseUrl}/payments/:id`
                                      }
                                    },
                                    [
                                      _c(
                                        "PaymentsTab",
                                        _vm._b(
                                          {
                                            on: {
                                              updated: _vm.onPaymentsChanged
                                            }
                                          },
                                          "PaymentsTab",
                                          _vm.paymentsTabProps,
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.payments.length > 0
                                    ? _c(
                                        "Route",
                                        {
                                          attrs: {
                                            path: `${_vm.baseUrl}/payments`,
                                            exact: ""
                                          }
                                        },
                                        [
                                          _c("Redirect", {
                                            attrs: {
                                              to: `${_vm.baseUrl}/payments/${_vm.payments[0].id}`
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "Route",
                                        {
                                          attrs: {
                                            path: `${_vm.baseUrl}/payments`
                                          }
                                        },
                                        [
                                          _c(
                                            "PaymentsTab",
                                            _vm._b(
                                              {
                                                on: {
                                                  updated: _vm.onPaymentsChanged
                                                }
                                              },
                                              "PaymentsTab",
                                              _vm.paymentsTabProps,
                                              false
                                            )
                                          )
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: `${_vm.baseUrl}/invoice` } },
                            [
                              !!_vm.pledge
                                ? _c("EditInvoice", {
                                    attrs: {
                                      pledgeId: _vm.pledge.id,
                                      showFundraiser: true
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: `${_vm.baseUrl}/receipts` } },
                            [
                              !!_vm.pledge
                                ? _c("EditReceipt", {
                                    attrs: {
                                      pledgeId: _vm.pledge.id,
                                      showFundraiser: true
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: `${_vm.baseUrl}/audit` } },
                            [
                              !!_vm.pledge
                                ? _c(
                                    "PledgeAuditLog",
                                    _vm._b(
                                      {},
                                      "PledgeAuditLog",
                                      _vm.auditProps,
                                      false
                                    )
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: `${_vm.baseUrl}` } },
                            [
                              _c(
                                "PledgeTab",
                                _vm._b(
                                  {
                                    on: {
                                      added: function($event) {
                                        return _vm.$emit("added")
                                      }
                                    }
                                  },
                                  "PledgeTab",
                                  _vm.pledgeTabProps,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        : _c(
            "PledgeTab",
            _vm._b(
              {
                on: {
                  added: function($event) {
                    return _vm.$emit("added")
                  }
                }
              },
              "PledgeTab",
              _vm.pledgeTabProps,
              false
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }